enum DateTimeFormats {
  DateWithTime = 'd-MMM-yyyy hh:mm a',
  DateOnly = 'd-MMM-yyyy',
  YearMonthDay = 'yyyy-MM-dd',
  FcDateFormat = 'dd-MM-yyyy',
}

export default DateTimeFormats;
